// src/store/api/newsApi.js

import { baseApi } from "./baseApi";

export const newsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getNewsFeed: builder.query({
      query: () => ({
        url: "/news/feed",
        method: "GET",
      }),

      transformResponse: (response) => {
        // Handles .NET $values wrapper
        if (Array.isArray(response)) return response;

        if (Array.isArray(response?.$values)) {
          return response.$values;
        }

        if (Array.isArray(response?.data)) {
          return response.data;
        }

        return [];
      },
    }),
  }),

  overrideExisting: false,
});

export const { useGetNewsFeedQuery } = newsApi;
